import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { useGetOrganizationSummaries } from "@src/api/organization-summaries/get-organization-summaries";
import { SkeletonGroup } from "@src/components/Utils/SkeletonGroup";
import { MeterLogDrawer } from "@src/features/admin/components/Drawers/MeterLogDrawer/MeterLogDrawer";
import { CreateSubscriptionDrawer } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/CreateSubscriptionDrawer";
import { ModifySubscriptionDrawer } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/ModifySubscriptionDrawer";
import { OrganizationOverviewTable } from "@src/features/admin/pages/overview/components/Tables/OrganizationOverviewTable/OrganizationOverviewTable";

const Loading = () => {
  return (
    <Grid item>
      <SkeletonGroup lines={5} />
    </Grid>
  );
};
export const AdminOverviewBody = () => {
  const billingOrgs = useGetOrganizationSummaries();

  return (
    <Grid container item direction={"column"} rowSpacing={5}>
      <Grid item>
        <IgTypography variant={"h1"} fontWeight={600}>
          Manage Organizations
        </IgTypography>
      </Grid>
      {billingOrgs.isSuccess ? (
        <OrganizationOverviewTable orgs={billingOrgs.data?.orgs || []} />
      ) : (
        <Loading />
      )}
      <CreateSubscriptionDrawer />
      <ModifySubscriptionDrawer />
      <MeterLogDrawer />
    </Grid>
  );
};
